import { useEffect, useState } from 'react';
import { useInterval } from 'react-use';

const FLASH_INTERVAL_IN_MILISECONDS = 2000;

interface InactiveTabTitleFlashSettings {
  originalTitle: string;
  inactiveTitle: string;
}

export const useInactiveTabTitleFlash = ({ originalTitle, inactiveTitle }: InactiveTabTitleFlashSettings) => {
  const [isRunning, setIsRunning] = useState(false);

  const focusEventHandler = () => {
    setIsRunning(false);
    document.title = originalTitle;
  };

  const blurEventHandler = () => {
    setIsRunning(true);
  };

  useInterval(
    () => {
      if (document.title === originalTitle) {
        document.title = inactiveTitle;
      } else {
        document.title = originalTitle;
      }
    },
    isRunning ? FLASH_INTERVAL_IN_MILISECONDS : null,
  );

  useEffect(() => {
    window.addEventListener('blur', blurEventHandler);
    window.addEventListener('focus', focusEventHandler);

    return () => {
      window.removeEventListener('focus', focusEventHandler);
      window.removeEventListener('blur', blurEventHandler);
    };
  }, []);
};
